import Typography from '@/components/shared/typography/typography.component';
import { CarIncludeType } from '../car-includes.type';
import { AVAILABLE_LANGUAGES } from '@/constants';
import Image from 'next/image';
import { CheckCircle } from 'public/Images';

export const CarIncludesDetailedItems = ({
    lang,
    toBeIcluded,
}: {
    lang: AVAILABLE_LANGUAGES;
    toBeIcluded: CarIncludeType[];
}) => {
    return (
        <div
            className={`md:grid md:grid-cols-${
                toBeIcluded.length > 6 ? 4 : toBeIcluded.length === 4 ? 2 : 3
            } md:gap-x-3`}
        >
            {toBeIcluded.map((item, index) => {
                return (
                    <div
                        key={index}
                        className="px-2.5 py-3 bg-gray-50 rounded-lg mb-3 flex gap-x-3"
                    >
                        <div className="flex-shrink-0">
                            <Image
                                src={item.icon}
                                alt={item.title.en}
                                width={40}
                            />
                        </div>
                        <div>
                            <Typography
                                variant="body2Medium"
                                className="text-gray-800"
                            >
                                {item.title[lang]}
                            </Typography>
                            <div
                                className="text-gray-600 text-caption"
                                dangerouslySetInnerHTML={{
                                    __html: item.subTitle[lang],
                                }}
                            />
                            {item.points && (
                                <div className="flex flex-col gap-y-1">
                                    {item.points.map((point, idx) => {
                                        return (
                                            <div
                                                key={idx}
                                                className="flex gap-x-2"
                                            >
                                                <Image
                                                    src={CheckCircle}
                                                    alt="check"
                                                    className="flex-shrink-0"
                                                />
                                                <Typography
                                                    variant="caption"
                                                    className="text-primary-700"
                                                >
                                                    {point[lang]}
                                                </Typography>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
